import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { api } from "../../helpers/utils";

export default function AdminHome() {
  const nav = useNavigate();
  const [totalUsers, setTotalUsers] = useState(0);

  const getTotalUsers = async () => {
    try {
      const res = await api.post("https://api1.pepchat.in/get-total-users");
      if (res.data.status === 100) {
        setTotalUsers(res.data.totalUsers || 0);
      }
    } catch (err) {
      console.error("Error fetching total users:", err);
    }
  };

  useEffect(() => {
    // Verify admin status on mount
    const isAdmin = localStorage.getItem('isAdmin');
    const token = localStorage.getItem('authToken');

    if (!isAdmin || !token) {
      localStorage.clear();
      nav('/login', { replace: true });
      return;
    }

    // Verify with backend - getTotalUsers will return 403 if not admin
    // which triggers the interceptor to clear auth and redirect
    getTotalUsers();
  }, [nav]);

  const Icons = {
    users: (
      <svg width="36" height="36" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3"></circle>
        <circle cx="24" cy="12" r="3"></circle>
        <path d="M6 28c0-4 3-7 6-7s6 3 6 7"></path>
        <path d="M18 28c0-4 3-7 6-7s6 3 6 7"></path>
      </svg>
    ),
    clock: (
      <svg width="36" height="36" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="18" cy="18" r="10"></circle>
        <path d="M18 12v6l4 2"></path>
      </svg>
    ),
    plus: (
      <svg width="36" height="36" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 6v24"></path>
        <path d="M6 18h24"></path>
      </svg>
    ),
    banner: (
      <svg width="36" height="36" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="6" width="28" height="20" rx="3"></rect>
        <path d="M4 14h28"></path>
      </svg>
    ),
    spark: (
      <svg width="36" height="36" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 4l2.5 6.5L27 13l-6.5 2.5L18 22l-2.5-6.5L9 13l6.5-2.5L18 4z"></path>
        <path d="M12 24l2 4m8-4l-2 4"></path>
      </svg>
    ),
    wallet: (
      <svg width="36" height="36" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="8" width="28" height="20" rx="3"></rect>
        <path d="M4 12h28"></path>
        <rect x="24" y="16" width="4" height="4" rx="1"></rect>
      </svg>
    ),
    reports: (
      <svg width="36" height="36" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M8 5h20v26H8z"></path>
        <path d="M13 12h10M13 18h10M13 24h6"></path>
      </svg>
    ),
  };

  const handleLogout = () => {
    try {
         localStorage.removeItem("authToken");
    localStorage.removeItem("isAdmin");
    nav("/login", { replace: true });
        
    } catch (error) {
        
    }
   
  };

  const cards = [
    { title: "Find User Details", icon: Icons.users, route: "/admin/users" },
    { title: "Waitlist Users", icon: Icons.clock, route: "/admin/waitlist" },
    { title: "Create Event", icon: Icons.plus, route: "/admin/create-event" },
    { title: "Add Banner", icon: Icons.banner, route: "/upload-ads" },
    { title: "Block user", icon: Icons.users, route: "/admin/block-user" },
    // { title: "Pepchat AI Tester", icon: Icons.spark, route: "/admin/ai-tester" },
    { title: "Creators Redeem Requests", icon: Icons.wallet, route: "/admin/redeem-requests" },
    { title: "PEP Coins Redeem Requests", icon: Icons.wallet, route: "/admin/pep-redeem-requests" },
    { title: "Reports", icon: Icons.reports, route: "/admin/reports" },
  ];

  return (
    <Wrapper>
      <HeaderRow>
        <HeaderArea>
          <MainTitle>Pepchat Admin</MainTitle>
          {/* <SubTitle>Calm overview of everything live in the ecosystem</SubTitle> */}
        </HeaderArea>
        <LogoutButton onClick={handleLogout}>Logout</LogoutButton>
      </HeaderRow>

      <StatsCard>
        <StatNumber>{totalUsers}</StatNumber>
        <StatCopy>
          <StatLabel>Total Users</StatLabel>
          {/* <StatHelper>Live count of people on the network</StatHelper> */}
        </StatCopy>
      </StatsCard>

      <Grid>
        {cards.map((c, i) => (
          <Card key={i} onClick={() => nav(c.route)}>
            <IconWrap>{c.icon}</IconWrap>
            <Label>{c.title}</Label>
          </Card>
        ))}
      </Grid>
    </Wrapper>
  );
}

/* ---------------- STYLES ---------------- */

const Wrapper = styled.div`
  min-height: 100vh;
  width: 100%;
  background: #000000;
  padding: 50px 20px 80px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;

`;

const HeaderArea = styled.div`
  text-align: center;
  margin-bottom: 30px;

  @media (max-width: 480px) {
    margin-bottom: 20px;
  }
`;

const HeaderRow = styled.div`
  width: min(900px, 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const MainTitle = styled.h1`
  font-size: 40px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0;

  @media (max-width: 480px) {
    font-size: 30px;
  }
`;

const SubTitle = styled.div`
  margin-top: 10px;
  font-size: 16px;
  color: #bdbdbd;

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

const StatsCard = styled.div`
  width: min(840px, 95%);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  padding: 26px 32px;
  background: #050505;
  border: 1px solid #303030;

  @media (max-width: 640px) {
    width: 90%;
    padding: 22px;
  }

  @media (min-width: 641px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

const StatNumber = styled.div`
  font-size: 54px;
  font-weight: 700;
  color: #ffffff;
  word-break: break-word;
`;

const StatLabel = styled.div`
  font-size: 18px;
  font-weight: 800;
  color: #ffffff;
`;

const StatHelper = styled.p`
  margin: 6px 0 0;
  font-size: 14px;
  color: #8c8c8c;
`;

const StatCopy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 100%;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 25px;
  width: 98%;
  max-width: 900px;
`;

const Card = styled.div`
  background: #050505;
  padding: 28px 22px;
  border: 1px solid #303030;
  cursor: pointer;
  text-align: center;
  transition: border 0.25s ease, transform 0.25s ease, background 0.25s ease;

  &:hover {
    transform: translateY(-8px);
    border-color: #ffffff;
    background: #000000;
  }
`;

const IconWrap = styled.div`
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
  color: #ffffff;
`;

const Label = styled.div`
  font-size: 18px;
  font-weight: 800;
  color: #ffffff;
`;

const LogoutButton = styled.button`
  border: 1px solid #ffffff;
  padding: 10px 18px;
  background: transparent;
  color: #ffffff;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #ffffff;
    color: #000000;
  }

  &:active {
    transform: scale(0.97);
  }
`;
